import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

@NgModule({
    imports: [
        SharedModule,
    ]
})
export class IntegrationClienteTipoSharedModule { }
